import { render } from "./DepartmentsList.vue?vue&type=template&id=19c47c90"
import script from "./DepartmentsList.vue?vue&type=script&lang=js"
export * from "./DepartmentsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__